import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { ThemeProvider } from '@material-ui/core/styles';
import Theme from '../theme/CustomTheme'
import NumberFormat from 'react-number-format';
import { FormControl, InputLabel, Select, MenuItem, CssBaseline, Paper, Button } from '@material-ui/core';
import useStyles from '../styles/CustomStyle'
import NavBar from './NavBar';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/moment';


export default function BasicInformation() {
    const classes = useStyles();

    const [selectedDate, handleDateChange] = React.useState("");

    return (
        <React.Fragment>
            <CssBaseline />
            <NavBar showMenu={true}/>
            <main className={`${classes.layout} layout`} >
                <Paper className={classes.paper} style={{ marginTop: 90 }} elevation={4}>
                    <Typography variant="h6" gutterBottom>
                        Commuter Information
                    </Typography>
                    <ThemeProvider theme={Theme}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    required
                                    id="fullName"
                                    name="fullName"
                                    label="Full name"
                                    fullWidth
                                    autoComplete="fname"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    id="institutionName"
                                    name="institutionName"
                                    label="Institution Name"
                                    fullWidth
                                    autoComplete="instname"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        clearable
                                        disableFuture
                                        value={selectedDate}
                                        placeholder="Date of birth"
                                        onChange={date => handleDateChange(date)}
                                        // maxDate={new Date()}
                                        format="DD/MM/YYYY"
                                        style={{
                                            marginTop: 16,
                                            width: "100%"
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Address"
                                    id="address"
                                    name="address"
                                    // onChange={handleChangeEmail}
                                    fullWidth
                                    autoComplete="address"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel id="thana-label">Thana</InputLabel>
                                    <Select
                                        labelId="thana"
                                        id="thana"
                                    // value={gender}
                                    // onChange={handleChange}
                                    >
                                        <MenuItem value={10}>Dhaka</MenuItem>
                                        <MenuItem value={20}>Chittagong</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <NumberFormat
                                    placeholder="Phone Number"
                                    style={{
                                        marginTop: 16,
                                        width: "100%"
                                    }}
                                    customInput={TextField}
                                    format="+88###########"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Email (optional)"
                                    id="email"
                                    name="email"
                                    // onChange={handleChangeEmail}
                                    fullWidth
                                    autoComplete="email"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Brand Promoter Name"
                                    id="brand-promoter"
                                    name="brand-promoter"
                                    // onChange={handleChangeEmail}
                                    fullWidth
                                    autoComplete="brand-promoter"
                                />
                            </Grid>

                        </Grid>
                        <div className={classes.buttons}>
                            <Button
                                variant="contained"
                                color="primary"
                                // onClick={handleNext}
                                className={classes.button}
                            >
                                Submit
                                </Button>
                        </div>
                    </ThemeProvider>
                </Paper>
            </main>
        </React.Fragment>
    );
}